import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { MonitoringTiersState } from "../../models/mp-admin/monitoring-tiers-state";

const initialState: MonitoringTiersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.monitoringTiers.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.monitoringTiers.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.monitoringTiers.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.monitoringTiers.invalidate, () => initialState)
);

export function monitoringTiersReducer(
	state: MonitoringTiersState | undefined,
	action: Action
): MonitoringTiersState {
	return reducer(state, action);
}
